import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTransition, animated } from 'react-spring/web.cjs';
import theme from '../../../theme';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
`;

const BackgroundImageSlide = styled.div`
  position: absolute;
  display: flex;
  background: ${theme.colors.medium} url(${(props) => props.src}) center center no-repeat;
  background-size: cover;
  width: 100%;
  height: 100%;
`;

const Slide = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  will-change: opacity;
  user-select: none;
  pointer-events: none;
`;

function Slider({ speed, children }) {
  const [index, set] = useState(0);
  const items = children.map((child, index) => (
    <Slide key={index}>{child}</Slide> // eslint-disable-line react/no-array-index-key
  ));
  const transitions = useTransition(items[index], (item) => item.key, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { tension: 100, friction: 50 },
  });
  useEffect(
    () => {
      const interval = setInterval(() => set((state) => (state + 1) % children.length), speed);
      return () => clearInterval(interval);
    },
    [children.length, speed],
  );
  return (
    <Wrapper>
        {transitions.map(({ item, props, key }) => ( // eslint-disable-line
          <animated.div
            key={key}
            style={{ ...props }}
          >
            {item}
          </animated.div>
        ))}
    </Wrapper>
  );
}
Slider.propTypes = {
  speed: PropTypes.number,
};
Slider.defaultProps = {
  speed: 4500,
};

export default Slider;

export { BackgroundImageSlide };
